import React, { useMemo, useState } from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity } from 'react-native';
import { Text, TextInput } from 'react-native-paper';
import { useGetAmProductsQuery, type AmProduct } from '../redux/services/amproductApi';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface Props {
  value?: number | null;
  onSelect: (product: AmProduct | null) => void;
  label?: string;
}

/** Searchable inline picker over the Asset Product master (no Portal: the app has no Paper Provider). */
const ProductPicker = ({ value, onSelect, label = 'Asset product (optional)' }: Props) => {
  const { data: products = [] } = useGetAmProductsQuery();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const selected = products.find(p => Number(p.pt_id) === Number(value));

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    const list = q
      ? products.filter(p => [p.pt_code, p.pt_name, p.pt_brand, p.pt_model, p.category_name].some(v => (v || '').toLowerCase().includes(q)))
      : products;
    return list.slice(0, 60);
  }, [products, query]);

  const choose = (p: AmProduct | null) => {
    onSelect(p);
    setOpen(false);
    setQuery('');
  };

  return (
    <View style={styles.wrap}>
      <TouchableOpacity style={styles.select} onPress={() => setOpen(!open)}>
        <Text style={selected ? undefined : styles.placeholder}>
          {selected ? `${selected.pt_code} - ${selected.pt_name}${selected.pt_brand ? ` (${selected.pt_brand})` : ''}` : label}
        </Text>
      </TouchableOpacity>
      {open && (
        <View style={styles.panel}>
          <TextInput
            placeholder={tp("Search code, name, brand, model")}
            value={query}
            onChangeText={setQuery}
            mode="outlined"
            dense
            style={styles.search}
          />
          <ScrollView style={styles.list} nestedScrollEnabled keyboardShouldPersistTaps="handled">
            <TouchableOpacity style={styles.item} onPress={() => choose(null)}>
              <Text style={styles.placeholder}><T>Custom asset (no product)</T></Text>
            </TouchableOpacity>
            {filtered.map(p => (
              <TouchableOpacity key={String(p.pt_id)} style={styles.item} onPress={() => choose(p)}>
                <Text>{p.pt_code} - {p.pt_name}</Text>
                {p.pt_brand || p.pt_model || p.category_name ? (
                  <Text style={styles.sub}>{[p.category_name, p.pt_brand, p.pt_model].filter(Boolean).join('  ·  ')}</Text>
                ) : null}
              </TouchableOpacity>
            ))}
            {filtered.length === 0 && <Text style={[styles.sub, { padding: 12 }]}><T>No products found</T></Text>}
          </ScrollView>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { marginBottom: 10 },
  select: { borderWidth: 1, borderColor: '#ddd', borderRadius: 4, padding: 12, backgroundColor: '#fafafa' },
  placeholder: { color: '#777' },
  panel: { borderWidth: 1, borderColor: '#ddd', borderRadius: 4, backgroundColor: '#fff', marginTop: 4, padding: 6 },
  search: { marginBottom: 6 },
  list: { maxHeight: 220 },
  item: { padding: 10, borderBottomWidth: 1, borderBottomColor: '#eee' },
  sub: { fontSize: 11, color: '#666', marginTop: 2 }
});

export default ProductPicker;
